var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnBlockUserOptionDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "27px",
    viewBox: "0 0 23 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unBlockUserOptionDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,15 C7.35786439,15 4,11.6421356 4,7.5 C4,3.35786439 7.35786439,0 11.5,0 C15.6421356,0 19,3.35786439 19,7.5 C19,11.6421356 15.6421356,15 11.5,15 Z M11.5,13.4210526 C14.7701071,13.4210526 17.4210526,10.7701071 17.4210526,7.5 C17.4210526,4.22989291 14.7701071,1.57894737 11.5,1.57894737 C8.22989291,1.57894737 5.57894737,4.22989291 5.57894737,7.5 C5.57894737,10.7701071 8.22989291,13.4210526 11.5,13.4210526 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Dropdown---After-interaction",
    transform: "translate(-678.000000, -282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unBlockUserOptionDesktop",
    transform: "translate(678.000000, 282.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5015007,18.7165443 C15.834019,18.689248 19.9171702,21.2529769 21.275714,26.251413 C21.4634666,26.9422036 22.7421015,26.8967542 22.9664361,26.3182534 C22.9927762,26.2503292 23.0045816,26.1750562 22.9983799,26.0927635 C22.0862472,14.0166228 1.07567312,13.9216279 0.00343850387,26.0927635 C-0.0708285449,26.9357827 1.07567312,27.6213891 1.72728735,26.0927635 C3.28717868,20.9214107 7.52179376,18.7416178 11.5015007,18.7165443 Z",
    id: "Fill-1",
    fill: "#646464"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnBlockUserOptionDesktop);
export default __webpack_public_path__ + "static/media/unBlockUserOptionDesktop.49518f4ec6f1c8e6202366fa5b01b48a.svg";
export { ForwardRef as ReactComponent };